// store/data/thunks.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import { dataService } from '../../services/data.service';
import { GetStudyDataRequest, GetCompanyDataRequest } from '@/types/data';

// --------------------------------------- DATA ANALYTICS ---------------------------------------

export const getStudyData = createAsyncThunk(
  'data/getStudyData',
  async (params: GetStudyDataRequest | undefined, { rejectWithValue }) => {
    try {
      const response = await dataService.getStudyData(params);
      console.log('Fetched study data:', response);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch study data');
    }
  }
);

export const getCompanyData = createAsyncThunk(
  'data/getCompanyData',
  async (params: GetCompanyDataRequest | undefined, { rejectWithValue }) => {
    try {
      const response = await dataService.getCompanyData(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch company data');
    }
  }
);

// ------------------------------------ GROUPED EXPORTS ------------------------------------

export const data = {
  getStudyData,
  getCompanyData,
};
